import * as _ from 'underscore';
import * as $ from 'jquery';

const moment = require('pdc-platform-moment');

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import * as DateTimeFunctions from '../../../../_common/platform/ts/DateTimeFunctions';
import { IValuesCollection } from '../../ts/appTheme';

import {
    GlobalFilterDateType,
    IMomentDatesForPeriodFilter,
    IPeriodDefaults,
    IPeriodFilter,
    IPeriodFilterOptions,
    IPeriodFilterWidgetParameters,
    IScopeOptions
} from './Interfaces';

export const periodFilterThemeFields = {
    animationEnabled: 'period-filter-animation-enabled',
    usePlaceholder: 'period-filter-use-placeholder',
    verticalSpacing: 'period-filter-vertical-spacing',
    layoutType: 'period-filter-layout-type',
    applyValueMode_useButtons: 'period-filter-show-today-button',
    currentDateMode: 'period-filter-current-date-mode',
    alignDatesForCalendarPeriod: 'period-filter-align-dates-for-calendar-period',
    //putFromAndToValuesToVariables: 'period-filter-put-from-and-to-values-to-variables',

    section_Buttons: 'period-filter-buttons',
    justifyButtons: 'period-filter-justify-toolbar-buttons',
    showResetButton: 'period-filter-show-reset-button',
    resetButtonShowMode: 'period-filter-reset-button-show-mode',
    showApplyButton: 'period-filter-show-apply-button',
    showRefreshButton: 'period-filter-show-refresh-button',
    refreshButtonShowMode: 'period-filter-refresh-button-show-mode',
    buttonsPosition: 'period-filter-toolbar-buttons-position',
    resetButtonMode: 'period-filter-reset-button-mode'
};

function normalizePeriodFilterWidgetParameters(widgetParameters: IPeriodFilterWidgetParameters) {
    const result = $.extend(true, {}, widgetParameters);

    if (result.radioNoPeriodFiltering) {
        result.showTimeSlider = false;
    }

    // for back compability: Percentage is removed. It it was set, then set
    if (result.radioDefaultPercentage) {
        result.radioDefaultPercentage = false;
        result.radioFullFilterPeriod = true;
    }

    // Show NoRestriction if TimeSlider hidden:
    if (result.showTimeSlider === false) {
        // Hour or Minute
        result.maxLengthPeriod = 0;
    }
    // Hide Y-Q-M buttons if One Day/Hour/Minute is selected:
    // VR: moved from here to code. No try to set it here!
    if (result.maxLengthPeriod > 0 || result.optionRadioUseOneDay || result.showOneDayGuiSwitcher) {
        // periodFilter.showYear = false;
        // periodFilter.showQuarter = false;
        // periodFilter.showMonth = false;
        result.showTimeInPicker = false;
    }

    // Hide Length of bacckward/forward if the FBButtons is hidden:
    if (result.showFBButtons === false) {
        // Hour or Minute
        result.showActualPeriodSelection = false; // it is because NO SENSE if we work with hours/minutes/seconds without TimeSlider!
    }

    return result;
}

export function formatPeriodDate(inputDate, timeZoneFromTheme: DateTimeFunctions.ITimeZone) {
    // Format of 'timeZoneFromTheme': hours: 1,minutes: 30,offset: "01:30",
    // offsetString: "+01:30",offsetValue: 90,sign: "+", useOffset: true
    // VR: a culture here is not needed: we work only with "YYYY-MM-DDTHH:mm:ssZXX:XX" format
    if (inputDate == null) {
        // for defaults FROM and TO because they can be NULL here;
        return null;
    }

    // var loc = moment(inputDate);
    // Globalization.applyCulture(langMoment);
    // if (loc.seconds() == 59 && needAdd1 === true) {
    //     loc.add(1, 's');
    // }
    // if (Utilities.DateTimeFunctions.timeZoneIsUsed(timeZoneFromTheme)) {
    //     return Globalize.formatDate(loc.toDate(), {raw: "yyyy-MM-ddTHH':'mm':'ss"}) +
    //         Utilities.DateTimeFunctions.getOffsetInString(timeZoneFromTheme,
    //             Globalize.formatDate(loc.toDate(), {raw: "yyyy-MM-ddTHH':'mm':'ss"}));
    // }
    // return Globalize.formatDate(loc.toDate(), {raw: "yyyy-MM-ddTHH':'mm':'ssZ"});

    const loc = moment(inputDate);
    // if (loc.seconds() == 59 && needAdd1 === true) {         // add 1 sec to make it 00:00:00 to do ?equal() operation
    //     loc.add(1, 's');
    // }
    // else if(loc.seconds() == 00 && needAdd1 === false) {  //data from DevExpress slider? Then make it 23:59:59
    //     loc.subtract(1, 's');
    // }

    if (DateTimeFunctions.timeZoneIsUsed(timeZoneFromTheme)) {
        return (
            loc.format('YYYY-MM-DDTHH:mm:ss') +
            DateTimeFunctions.getOffsetInString(timeZoneFromTheme, loc.format('YYYY-MM-DDTHH:mm:ss'))
        );
    }

    return loc.format('YYYY-MM-DDTHH:mm:ssZ');
}

export function formatDateMinus(inputDate) {
    const loc = moment(inputDate);

    if (loc.seconds() == 0) {
        loc.subtract(1, 's');
    }

    return loc;
}

export function getMinMaxYear(widgetParameters: IPeriodFilterWidgetParameters) {
    let dateMin: Moment = moment(widgetParameters.timeMaxFilterDateMin);
    let dateMax: Moment = moment(widgetParameters.timeMaxFilterDateMax);

    if (!dateMin.isValid()) {
        dateMin = moment();
    }

    if (!dateMax.isValid()) {
        dateMax = moment();
    }

    const showBeforeCurrYear = dateMin.startOf('year').year();
    const showAfterCurrYear = dateMax.endOf('year').subtract(3, 'hour').year();

    return {
        minYear: showBeforeCurrYear,
        maxYear: showAfterCurrYear
    };
}

// Creates Moment Date from a string or makes a copy from a Moment Date.
export function getMomentDate(value: GlobalFilterDateType): Moment {
    return value != null ? moment(value) : null;
}

// Returns either the input Date or Now():
export function getNotNullDate(inputDate: GlobalFilterDateType) {
    if (
        inputDate == null ||
        inputDate === '' ||
        (typeof inputDate === 'string' && inputDate.toLowerCase() === 'invalid date')
    ) {
        return moment();
    }

    return getMomentDate(inputDate);
}

// Gets the first and the last Time Parts (ex: year, Quater or Month) to make Period Date.
function getFirstAndLastTimeParts(timeParts: number | number[], result: ILastAndFirst) {
    if (typeof timeParts === 'number') {
        result.first = timeParts;
        result.last = timeParts;
    } else if (Array.isArray(timeParts) && timeParts.length > 0) {
        result.first = timeParts[0];
        result.last = timeParts[timeParts.length - 1];
    }
}

function normalizeDateTo(
    widgetParameters: IPeriodFilterWidgetParameters,
    from: GlobalFilterDateType,
    to: GlobalFilterDateType,
    oneDayPeriod: boolean
): { periodFrom: Moment; periodTo: Moment } {
    let periodFrom = getMomentDate(from);
    let periodTo = getMomentDate(to);

    if (oneDayPeriod) {
        // DATE ====================
        if (periodFrom != null) {
            periodTo = moment(periodFrom).hours(23).minutes(59).seconds(59);
            periodTo.add(1, 's');
        } else {
            periodTo = null;
        }
    } else {
        if (widgetParameters.maxLengthPeriod === 0) {
            if (widgetParameters.showTimeInPicker) {
                // DATE + TIME  =============================
                if (periodTo != null) {
                    periodTo = moment(periodTo).seconds(59);
                    periodTo.add(1, 's');
                }
            } else {
                // DATE ====================: again
                if (periodFrom != null) {
                    // See Issue 71058: Period Filter, when option Show Today Button is ON, then dateFrom is set with the current time instead of 00:00
                    periodFrom = moment(periodFrom).hours(0).minutes(0).seconds(0);
                }

                if (periodTo != null) {
                    periodTo = moment(periodTo).hours(23).minutes(59).seconds(59);
                    periodTo.add(1, 's');
                }
            }
        } else if (widgetParameters.maxLengthPeriod === 1) {
            // 1 DAY ===========================
            if (periodFrom != null) {
                periodFrom = moment(periodFrom);
                periodTo = moment(periodTo);

                let newFrom = moment(periodFrom);

                if (!widgetParameters.showTimeSlider) {
                    periodTo = newFrom.add(24, 'h');
                } else {
                    newFrom.add(24, 'h').add(1, 's');

                    if (periodFrom.isAfter(periodTo)) {
                        periodTo = periodFrom.add(4, 'h');
                    } else if (periodFrom.isBefore(periodTo) && newFrom.isAfter(periodTo)) {
                        //good
                    } else {
                        let hh = periodTo.hours();
                        let mm = periodTo.minutes();

                        periodTo = periodFrom.hours(hh).minutes(mm);

                        if (periodFrom.isAfter(periodTo)) {
                            periodTo = periodFrom.hours(23).minutes(59).seconds(59).add(1, 's');
                        }
                    }
                }

                //periodFilterState.globalFilterTo = periodTo;
            }
        }
    }
    /*else if (opt.optionRadioUseOneHour) {     // 1 HOUR ===========================
        // _from = { from: PeriodUtil.Functions.formatPeriodDate(periodFrom, timeZoneFromTheme) };
        // _to = { to: PeriodUtil.Functions.formatPeriodDate(periodTo, timeZoneFromTheme) };
    } else if (opt.optionRadioUseOneMinute) {     // 1 MINUTE ===========================
        //_from = { from: PeriodUtil.Functions.formatPeriodDate(periodFrom, timeZoneFromTheme) };
        //_to = { to: PeriodUtil.Functions.formatPeriodDate(periodTo, timeZoneFromTheme) };
    } else {
        alert('Period Filter cannot understand the current mode: date, datetime, 1day, 1 hour or 1minute?');
    }*/
    return { periodFrom: periodFrom, periodTo: periodTo };
}

export function getDatesFromConfig(
    widgetParameters: IPeriodFilterWidgetParameters,
    oldPeriodFilter: IMomentDatesForPeriodFilter,
    glob: IGlob
) {
    const periodFilter: IMomentDatesForPeriodFilter = {};

    let timeFullDateMin = null; // object type is moment()
    let timeFullDateMax = null; // object type is moment()

    // Full Filter Period =========================
    // "Explicit"
    if (widgetParameters.timeMaxFilterDateMin != null && widgetParameters.timeMaxFilterDateMin !== '') {
        // can be null OR ''
        timeFullDateMin = moment(widgetParameters.timeMaxFilterDateMin).startOf('day'); //can be null
    } else if (widgetParameters.showTimeSlider) {
        //WorkItem [55620]: Empty date “To” should be converted to date today only when TimeSlider is visible
        timeFullDateMin = moment().startOf('year');
    }

    if (widgetParameters.timeMaxFilterDateMax != null && widgetParameters.timeMaxFilterDateMax !== '') {
        // can be null OR ''
        timeFullDateMax = moment(widgetParameters.timeMaxFilterDateMax).endOf('day'); //can be null
    } else if (widgetParameters.showTimeSlider) {
        //WorkItem [55620]: Empty date “To” should be converted to date today only when TimeSlider is visible
        timeFullDateMax = moment().endOf('day');
    }

    let timeSlicerDateMin = timeFullDateMin;
    let timeSlicerDateMax = timeFullDateMax;

    // Default Period ==============================
    // "Explicit"
    if (widgetParameters.radioDefaultDateMinMax) {
        timeFullDateMin = null;

        if (widgetParameters.timeDefaultDateMin != null && widgetParameters.timeDefaultDateMin !== '') {
            // can be null OR ''
            timeFullDateMin = moment(widgetParameters.timeDefaultDateMin).startOf('day');
        }

        timeFullDateMax = null;

        if (widgetParameters.timeDefaultDateMax != null && widgetParameters.timeDefaultDateMax !== '') {
            // can be null OR ''
            timeFullDateMax = moment(widgetParameters.timeDefaultDateMax).endOf('day');
        } else if (widgetParameters.showTimeSlider) {
            //WorkItem [55620]: Empty date “To” should be converted to date today only when TimeSlider is visible
            timeFullDateMax = moment();
        }

        // "Percentage" - obsolete 21 May 2021, WI 117297
        // }         else if (wParams.radioDefaultPercentage) {
        //     if (timeFullDateMin == null) {
        //         timeFullDateMin = moment();
        //     }
        //     if (timeFullDateMax == null) {
        //         timeFullDateMax = moment();
        //     }

        //     let howDays = moment(timeFullDateMax).diff(
        //         moment(timeFullDateMin),
        //         'days'
        //     );
        //     howDays = howDays <= 1 ? 1 : howDays;

        //     const fromMinDays = parseInt(
        //         (howDays * wParams.spinnerDefaultFrom) / 100.0 + ''
        //     );
        //     timeFullDateMin = moment(timeFullDateMin).add(fromMinDays, 'day'); //deprecated!

        //     const fromMaxDays = parseInt(
        //         (howDays * (100.0 - wParams.spinnerDefaultTo)) / 100.0 + ''
        //     );
        //     timeFullDateMax = moment(timeFullDateMax).subtract(
        //         fromMaxDays,
        //         'day'
        //     ); //deprecated! Please use moment().subtract(number, period).

        // "Relative"
    } else if (widgetParameters.radioDefaultPeriod) {
        const dateMainStart = getNotNullDate(null);
        const dateMainFinish = getNotNullDate(null);
        const typeTo = widgetParameters.timeDefaultPeriodToType;
        const isExclude = widgetParameters.timeDefaultPeriodExcludeCurrent;

        timeFullDateMin = dateMainStart
            .startOf('day')
            .subtract(widgetParameters.timeDefaultPeriodFromN, widgetParameters.timeDefaultPeriodFromType);
        if (isExclude === false) {
            timeFullDateMax = dateMainFinish.endOf('day').add(widgetParameters.timeDefaultPeriodToN, typeTo); // deprecated
        } else {
            timeFullDateMax = dateMainFinish.endOf('day').subtract(widgetParameters.timeDefaultPeriodToN, typeTo);
        }

        if (widgetParameters.timeDefaultPeriodJustify) {
            timeFullDateMin = timeFullDateMin.startOf(widgetParameters.timeDefaultPeriodFromType);
            timeFullDateMax = timeFullDateMax.endOf(typeTo);
        }

        // "Full Period"
    } else if (widgetParameters.radioFullFilterPeriod) {
        timeSlicerDateMin = timeFullDateMin;
        timeSlicerDateMax = timeFullDateMax;
    } else if (widgetParameters.radioNoPeriodFiltering) {
        timeFullDateMin = null;
        timeFullDateMax = null;
        timeSlicerDateMin = null;
        timeSlicerDateMax = null;
    }

    periodFilter.globalFilterFrom = timeFullDateMin;
    periodFilter.globalFilterTo = timeFullDateMax;
    periodFilter.sliceFrom = timeSlicerDateMin;
    periodFilter.sliceTo = timeSlicerDateMax;

    if (widgetParameters.useFiscalMonthVariable) {
        //EVG: See Issue 90333.
        periodFilter.fiscalMonth = moment(periodFilter.globalFilterFrom).month() + 1;
    }

    if (widgetParameters.optionRadioUseOneDay || widgetParameters.maxLengthPeriod > 0) {
        let oneDayDate = periodFilter.globalFilterFrom;

        if (oneDayDate == null) {
            oneDayDate = periodFilter.globalFilterTo;
        }

        if (oneDayDate == null) {
            oneDayDate = widgetParameters.timeMaxFilterDateMin;
        }

        if (oneDayDate == null) {
            oneDayDate = widgetParameters.timeMaxFilterDateMax;
        }

        if (oneDayDate == null) {
            oneDayDate = moment();
        }

        periodFilter.globalFilterFrom = moment(oneDayDate);
        periodFilter.globalFilterTo = moment(oneDayDate);
        periodFilter.useOneDay = true;
    }

    const globalFilterFrom = getMomentDate(periodFilter.globalFilterFrom);
    const globalFilterTo = getMomentDate(periodFilter.globalFilterTo);

    if (globalFilterTo != null) {
        globalFilterTo.hours(23).minutes(59).seconds(59);

        // set the first data as |#---------|
        if (widgetParameters.optionRadioUseOneDay === false && widgetParameters.showTimeSlider) {
            if (widgetParameters.maxLengthPeriod === 1) {
                // One day
                globalFilterFrom.hours(0).minutes(0).seconds(0);
                periodFilter.sliceFrom = getMomentDate(periodFilter.globalFilterFrom);

                periodFilter.globalFilterTo = getMomentDate(periodFilter.globalFilterFrom).add(24, 'h');
                periodFilter.sliceTo = getMomentDate(periodFilter.sliceFrom).add(24, 'h');
            } else if (widgetParameters.maxLengthPeriod === 2) {
                // the NAME and VALUE are the same as in platform validator:
                const REG_EXP_HOUR_MINUTE_SECOND = /(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
                const regEx = new RegExp(REG_EXP_HOUR_MINUTE_SECOND);

                if (regEx.test(widgetParameters.inputStringOneMinute)) {
                    // VR: work fine (in runTime and in JEST !!!
                    //console.log('inputs=OK');
                } else {
                    glob.AppActions.showNotification_Warning('Invalid input string. Use one like: "23:30:59"');
                    widgetParameters.inputStringOneMinute = '15:00:00';
                }

                const arrTime = widgetParameters.inputStringOneMinute.split(':');

                globalFilterFrom
                    .hours(parseInt(arrTime[0]))
                    .minutes(parseInt(arrTime[1]))
                    .seconds(parseInt(arrTime[2]));
                periodFilter.sliceFrom = getMomentDate(periodFilter.globalFilterFrom);

                periodFilter.globalFilterTo = getMomentDate(periodFilter.globalFilterFrom).add(60, 'm');
                periodFilter.sliceTo = getMomentDate(periodFilter.sliceFrom).add(60, 'm');
            } else if (widgetParameters.maxLengthPeriod === 3) {
                // the NAME and VALUE are the same as in platform validator:
                const REG_EXP_HOUR_MINUTE_SECOND = /(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;
                const regEx = new RegExp(REG_EXP_HOUR_MINUTE_SECOND);

                // VR: not work: if (/(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])jQuery/g.exec(wParams.inputStringOneMinute))
                // VR: not work: if (REG_EXP_HOUR_MINUTE_SECOND.test(wParams.inputStringOneMinute))
                if (regEx.test(widgetParameters.inputStringOneMinute)) {
                    // VR: work fine (in runTime and in JEST !!!
                    //console.log('inputs=OK');
                } else {
                    glob.AppActions.showNotification_Warning('Invalid input string. Use one like: "23:30:59"');
                    widgetParameters.inputStringOneMinute = '15:00:00';
                }

                const arrTime = widgetParameters.inputStringOneMinute.split(':');

                globalFilterFrom
                    .hours(parseInt(arrTime[0]))
                    .minutes(parseInt(arrTime[1]))
                    .seconds(parseInt(arrTime[2]));
                periodFilter.sliceFrom = getMomentDate(periodFilter.globalFilterFrom);

                globalFilterFrom.add(30, 's');
                periodFilter.globalFilterTo = getMomentDate(periodFilter.globalFilterFrom).add(60, 's');
                periodFilter.sliceTo = getMomentDate(periodFilter.sliceFrom).add(60, 's');
            }
        }
    }

    const periodDefaults: IPeriodDefaults = {
        defaultFrom: getMomentDate(periodFilter.globalFilterFrom),
        defaultTo: getMomentDate(periodFilter.globalFilterTo)
    };

    // Find Default TimeParts:  && !wParams.showFromTo
    if (widgetParameters.yearTimepart) {
        const yearFrom = globalFilterFrom == null ? null : globalFilterFrom.year();
        const yearTo = globalFilterTo == null ? null : globalFilterTo.year();

        if (yearFrom == null && yearTo == null) {
            periodDefaults.defaultYear = periodFilter.sliceTo != null ? periodFilter.sliceTo.year() : null; //WI:103169 moment().year();
        } else if (yearFrom != null && yearTo != null) {
            if (yearFrom === yearTo) {
                periodDefaults.defaultYear = yearFrom;
            } else {
                periodDefaults.defaultYear = _.range(yearFrom, yearTo + 1);
            }
        } else {
            periodDefaults.defaultYear = yearFrom || yearTo;
        }

        if (widgetParameters.showFromTo === false) {
            periodFilter.timePartYear = periodDefaults.defaultYear;

            if (periodDefaults.defaultYear != null) {
                periodFilter.globalFilterTo = null;
                periodFilter.globalFilterFrom = null;
            }
        } else {
            periodFilter.timePartYear = oldPeriodFilter.timePartYear;
        }

        periodFilter.timePartQuarter = oldPeriodFilter.timePartQuarter;
        periodFilter.timePartMonth = oldPeriodFilter.timePartMonth;
    }

    return {
        periodFilter: periodFilter,
        periodDefaults: periodDefaults
    };
}

interface ILastAndFirst {
    last?: number;
    first?: number;
}

// export function getPutFromAndToValuesToVariables(theme: IValuesCollection) {
//     return theme[periodFilterThemeFields.putFromAndToValuesToVariables] !== false;
// }

export function allowNullIsAllowed(widgetParameters: IPeriodFilterWidgetParameters) {
    return (
        widgetParameters.radioNoPeriodFiltering ||
        (!widgetParameters.showTimeSlider && widgetParameters.maxLengthPeriod === 0)
    );
}

export function getAllowNullForFromAndTo(widgetParameters: IPeriodFilterWidgetParameters) {
    return widgetParameters.allowNull !== false && allowNullIsAllowed(widgetParameters);
}

export function createFilterForGlobalState(
    widgetParameters: IPeriodFilterWidgetParameters,
    periodDefaults: IPeriodDefaults,
    periodFilterState: IMomentDatesForPeriodFilter,
    scopeOptions: IScopeOptions,
    theme: IValuesCollection,
    clearTimeParts?: boolean
) {
    const result: IPeriodFilter = {};
    const allowNull = getAllowNullForFromAndTo(widgetParameters);
    const timeZoneFromTheme = DateTimeFunctions.getTimeZoneFromTheme(theme);
    const { useOneDay } = periodFilterState;
    const options: IPeriodFilterOptions = {
        allowNull: allowNull,
        oneDayPeriod: useOneDay
    };

    let { periodFrom, periodTo } = normalizeDateTo(
        widgetParameters,
        periodFilterState.globalFilterFrom,
        periodFilterState.globalFilterTo,
        useOneDay
    );

    if (widgetParameters.yearTimepart && !clearTimeParts) {
        const getYear: ILastAndFirst = {};
        const getMonth: ILastAndFirst = { first: 0, last: 11 };
        const { minYear, maxYear } = getMinMaxYear(widgetParameters);
        const normalizedDefaultPeriods = normalizeDateTo(
            widgetParameters,
            periodDefaults.defaultFrom,
            periodDefaults.defaultTo,
            useOneDay
        );

        let noTimepartIsUsed = true; // if all Timepart are NULL;

        options.minYear = minYear;
        options.maxYear = maxYear;
        options.defaultYear = periodDefaults.defaultYear;
        options.defaultFrom = formatPeriodDate(normalizedDefaultPeriods.periodFrom, timeZoneFromTheme);
        options.defaultTo = formatPeriodDate(normalizedDefaultPeriods.periodTo, timeZoneFromTheme);

        if (periodFilterState.timePartYear != null && !_.isEqual(periodFilterState.timePartYear, [])) {
            getFirstAndLastTimeParts(periodFilterState.timePartYear, getYear);

            result.year = periodFilterState.timePartYear;
            noTimepartIsUsed = false;
        }

        if (periodFilterState.timePartQuarter != null && !_.isEqual(periodFilterState.timePartQuarter, [])) {
            getFirstAndLastTimeParts(periodFilterState.timePartQuarter, getMonth);

            getMonth.first = (getMonth.first - 1) * 3 + 1 - 1;
            getMonth.last = getMonth.last * 3 - 1;
            result.quarter = periodFilterState.timePartQuarter;
            noTimepartIsUsed = false;

            // See Issue 91719. Normalized periodTo can be set to the next year, but it must be in the same year(s) range.
            if (periodFrom != null && (getYear.first == null || getYear.last == null)) {
                getYear.first = getYear.last = periodFrom.year();
            }
        }

        if (periodFilterState.timePartMonth != null && !_.isEqual(periodFilterState.timePartMonth, [])) {
            getFirstAndLastTimeParts(periodFilterState.timePartMonth, getMonth);

            getMonth.first--;
            getMonth.last--;
            result.month = periodFilterState.timePartMonth;
            noTimepartIsUsed = false;

            // See Issue 91719. Normalized periodTo can be set to the next year, but it must be in the same year(s) range.
            if (periodFrom != null && (getYear.first == null || getYear.last == null)) {
                getYear.first = getYear.last = periodFrom.year();
            }
        }

        // if (periodFrom == null && periodTo == null &&
        //     (periodFilterState.tPartYear == null || _.isEqual(periodFilterState.tPartYear, []))) {
        //     attributesGlobal = _.extend(attributesGlobal, { year: periodDefaults.defaultYear });
        // }

        if (getYear.first == null || getYear.last == null) {
            if (periodFrom != null && periodTo != null) {
                getYear.first = periodFrom.year();
                getYear.last = periodTo.year();
            } else {
                getYear.first = options.minYear;
                getYear.last = options.maxYear;
            }
        }

        // not set the Period if there is mode "No Filtering" has set:
        if (!widgetParameters.radioNoPeriodFiltering && !noTimepartIsUsed) {
            const newPeriod = normalizeDateTo(
                widgetParameters,
                moment([getYear.first, getMonth.first, 1]),
                moment([getYear.last, getMonth.last]).endOf('month'),
                useOneDay
            );

            periodFrom = newPeriod.periodFrom;
            periodTo = newPeriod.periodTo;
        }
    }

    if (periodFrom != null) {
        result.from = formatPeriodDate(periodFrom, timeZoneFromTheme);
    }

    if (periodTo != null) {
        result.to = formatPeriodDate(periodTo, timeZoneFromTheme);
    }

    result.options = options;

    //const putFromAndToValuesToVariables = getPutFromAndToValuesToVariables(theme);

    //if (putFromAndToValuesToVariables) {
    result.variables = {
        from: result.from || null,
        to: result.to || null,
        fiscalMonth: result.timePeriodStartMonth || null
    };
    //}

    if (widgetParameters.useFiscalMonthVariable) {
        if (result.variables == null) {
            result.variables = {};
        }

        result.variables.fiscalMonth = periodFilterState.fiscalMonth;
    }

    if (scopeOptions != null) {
        result.scopeOptions = scopeOptions;
    }

    return result;
}

export function buildPeriodFilterWidgetPeriodFilter(
    widgetParameters: IPeriodFilterWidgetParameters,
    scopeOptions: IScopeOptions,
    theme: IValuesCollection,
    glob: IGlob
) {
    widgetParameters = normalizePeriodFilterWidgetParameters(widgetParameters);

    const data = getDatesFromConfig(
        widgetParameters,
        {
            globalFilterFrom: moment(),
            globalFilterTo: moment(),
            sliceFrom: moment(),
            sliceTo: moment()
        },
        glob
    );

    return createFilterForGlobalState(widgetParameters, data.periodDefaults, data.periodFilter, scopeOptions, theme);
}
